import { Component } from "@angular/core";

@Component({
  selector: "app-unsupported-browser",
  templateUrl: "./unsupported-browser.component.html",
  styleUrl: "./unsupported-browser.component.scss",
})
export class UnsupportedBrowserComponent {}
